import {LoginData, User} from "@/types/User";
import {endpoint} from "@/utils/api/Conf";

import {RequestError} from "@/types/RequestError";
import {setCookie} from "@/utils/hooks/useCookies";

export const loginRequest = async (data: LoginData) => {
  try {
    const init: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
    const response = await fetch(endpoint + 'auth/login', init);
    if (response.ok) {
      const usr = await response.json()
      const usrData = {email: data.email, ...usr}
      return usrData as User;
    }
    return await response.json() as RequestError;
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
export const getUserFromStorage = () => {
  const user = localStorage.getItem('user');
  if (!user) return null
  return JSON.parse(user) as User;
};
export const setUserInStorage = (data: User) => {
  localStorage.setItem('user', JSON.stringify(data));
};
export const removeUserInStorage = () => {
  localStorage.removeItem('user');
  setCookie('loginNotification', '0', {expires: 1})
};
